import { Navigate, RouteObject, useRoutes } from 'react-router-dom';
import OrderManagement from './OrderManagement';

const OrderManagementLayout: RouteObject[] = [
  {
    path: '/',
    element: (
      <OrderManagement />
    ),
  },
  { path: '*', element: <Navigate to="/404" /> },
];

const OrderManagementRoutes = () => useRoutes(OrderManagementLayout);
export default OrderManagementRoutes;
